// @flow

import { resolve, reject } from 'redux-optimist-promise';

import { fetch, clear, open, close } from 'Store/member-space/constants.helper';

const BOOKING_DETAILS = 'BOOKING_DETAILS';
const BOOKING_ATTENDEES_PACKAGE = 'BOOKING_ATTENDEES_PACKAGE';
const BOOKING_PRICE_AND_PAYMENT = 'BOOKING_PRICE_AND_PAYMENT';
const BOOKING_STAY_FORMALITIES = 'BOOKING_STAY_FORMALITIES';
const BOOKING_TRANSPORT = 'BOOKING_TRANSPORT';
const CHILDCARE_INFORMATIONS_MODAL = 'CHILDCARE_INFORMATIONS_MODAL';
const PACKAGE_UPSELL_INFORMATIONS_MODAL = 'PACKAGE_UPSELL_INFORMATIONS_MODAL';

export const FETCH_BOOKING_DETAILS = fetch(BOOKING_DETAILS);
export const FETCH_BOOKING_DETAILS_RESOLVED = resolve(FETCH_BOOKING_DETAILS);
export const FETCH_BOOKING_DETAILS_REJECTED = reject(FETCH_BOOKING_DETAILS);
export const CLEAR_BOOKING_DETAILS = clear(BOOKING_DETAILS);

export const FETCH_BOOKING_ATTENDEES_PACKAGE = fetch(BOOKING_ATTENDEES_PACKAGE);
export const FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED = resolve(FETCH_BOOKING_ATTENDEES_PACKAGE);
export const FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED = reject(FETCH_BOOKING_ATTENDEES_PACKAGE);
export const CLEAR_BOOKING_ATTENDEES_PACKAGE = clear(BOOKING_ATTENDEES_PACKAGE);

export const FETCH_BOOKING_PRICE_AND_PAYMENT = fetch(BOOKING_PRICE_AND_PAYMENT);
export const FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED = resolve(FETCH_BOOKING_PRICE_AND_PAYMENT);
export const FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED = reject(FETCH_BOOKING_PRICE_AND_PAYMENT);
export const CLEAR_BOOKING_PRICE_AND_PAYMENT = clear(BOOKING_PRICE_AND_PAYMENT);

export const FETCH_BOOKING_STAY_FORMALITIES = fetch(BOOKING_STAY_FORMALITIES);
export const FETCH_BOOKING_STAY_FORMALITIES_RESOLVED = resolve(FETCH_BOOKING_STAY_FORMALITIES);
export const FETCH_BOOKING_STAY_FORMALITIES_REJECTED = reject(FETCH_BOOKING_STAY_FORMALITIES);
export const CLEAR_BOOKING_STAY_FORMALITIES = clear(BOOKING_STAY_FORMALITIES);

export const FETCH_BOOKING_TRANSPORT = fetch(BOOKING_TRANSPORT);
export const FETCH_BOOKING_TRANSPORT_RESOLVED = resolve(FETCH_BOOKING_TRANSPORT);
export const FETCH_BOOKING_TRANSPORT_REJECTED = reject(FETCH_BOOKING_TRANSPORT);
export const CLEAR_BOOKING_TRANSPORT = clear(BOOKING_TRANSPORT);

export const OPEN_CHILDCARE_INFORMATIONS_MODAL = open(CHILDCARE_INFORMATIONS_MODAL);
export const CLOSE_CHILDCARE_INFORMATIONS_MODAL = close(CHILDCARE_INFORMATIONS_MODAL);

export const FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL = fetch(PACKAGE_UPSELL_INFORMATIONS_MODAL);
export const FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED = resolve(
  FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL,
);
export const FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_REJECTED = reject(
  FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL,
);
export const CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL = clear(PACKAGE_UPSELL_INFORMATIONS_MODAL);
export const OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL = open(PACKAGE_UPSELL_INFORMATIONS_MODAL);
export const CLOSE_PACKAGE_UPSELL_INFORMATIONS_MODAL = close(PACKAGE_UPSELL_INFORMATIONS_MODAL);
